/* eslint-disable no-underscore-dangle */
/* eslint-disable react/destructuring-assignment */
import { CloseCircleOutlined, MoreOutlined } from "@ant-design/icons";
import { useMutation } from "@apollo/client";
import { Avatar, Button, Drawer, Dropdown, Form, Image, message, Tooltip } from "antd";
import React, { useState } from "react";
import { CREATE_EMAIL, UPDATE_EMAIL_STATUS } from "../../../../graphql/mutation";
import DownIcon from "../../../../icons/DownIcon";
import DeleteIcon from "../../../../icons/js/DeleteIcon";
import { ReplyIcon } from "../../../../icons/js/EmailIcons";
import { convertUtcToLocal } from "../../../../library/utils";
import { convertToInitials } from "../../../layoutComponent/layoutHelpers";
import { dateFromNow, ReplyEmail } from "../Emails";
import { parseEmailReply } from "../engagementHelpers";
import { CancelScheduleConfirmation } from "../leadConsent";
import { AccessPermissionAction } from "../../../../library/constants";
import { checkAccessPermission } from "../../../../library/helpers";
import { cleanHtmlForPreview } from "../../../../utils/htmlHelpers";
import { EMAIL_TYPE_ENUMS, renderEmailStatus } from "../../../../constant/EmailConstant";
import ReplayIcon from "../../../../icons/svg/replay-icon.svg";
import MoreIcon from "../../../../icons/svg/MoreOutlined.svg";
import { EmailTypeIcon } from "../../../email-view/emailHeader";

/**
 *
 * @param {{thread:import("./emailMockData").EmailsData, index:number,setscheduleEmailCancelModal:import("react").Dispatch<import("react").SetStateAction<boolean>>,selectedEmail:import("./emailMockData").EmailsData,refetchEmails:()=>any,refetchEmailListFn:()=>any }} props
 * @returns
 */
export const ThreadsJSX = props => {
  const [emailForm] = Form.useForm();
  const [isExpanded, setIsExpanded] = useState(false);
  const [deleteModal, setdeleteModal] = useState(false);
  const fromDetails =
    props.thread.message.direction === "FROM_LEAD"
      ? `${props.thread.from_} ${props.thread.from_}`
      : `${props?.thread?.message?.user?.fullName || ""} ${props.thread.from_}`;
  const toDetails =
    props.thread.message.direction === "TO_LEAD"
      ? `${props?.thread?.lead?.fullName} ${props.thread.to}`
      : `${props?.thread?.message?.user?.fullName || ""} ${props.thread.to}`;

  const [showReply, setshowReply] = useState({
    visible: false,
    email: "",
    id: "",
    showSubject: false,
    mode: "Reply",
    emailData: null,
  });
  const { isReply, newMessage, originalMessage } = parseEmailReply(props.thread.bodyHtml);
  const [createEmail, { loading: emailLoader }] = useMutation(CREATE_EMAIL);
  const [updateEmailStatus, { loading: updateStatusLoader }] = useMutation(UPDATE_EMAIL_STATUS);
  const [mediaUploadLoader, setMediaUploadLoader] = useState(false);
  const [isMessageExpanded, setIsMessageExpanded] = useState(false);
  // This user permission is check for the user to delete/tra email
  const canDeleteEmail = checkAccessPermission(AccessPermissionAction.EMAIL_MANAGEMENT_DELETE);
  // This user permission is check for the user to send/reply/forward email
  const canSendEmail = checkAccessPermission(AccessPermissionAction.EMAIL_MANAGEMENT_SEND);

  const handleDelete = async () => {
    console.log("delete email", props.thread.sesMessageId);
    const res = await updateEmailStatus({
      variables: {
        action: "DELETE",
        sesMessageIds: [props.thread.sesMessageId],
      },
    });
    if (res.data.updateEmailStatus.statusCode === 200) {
      message.success(res.data.updateEmailStatus.message);
      props.refetchEmails();
      props.refetchEmailListFn();
      setdeleteModal(false);
    } else {
      message.error(res.data.updateEmailStatus.message);
    }
  };

  const emailActionOptions = [];

  if (canDeleteEmail) {
    emailActionOptions.push({
      label: "Delete",
      key: "DELETE",
      icon: <DeleteIcon size="20" color="#64748B" />,
      onClick: e => {
        e.domEvent.stopPropagation();
        setdeleteModal(true);
      },
    });
  }

  const emailScheduledOptions = [];

  if (canDeleteEmail) {
    emailScheduledOptions.push(
      {
        label: "Cancel Schedule",
        icon: <CloseCircleOutlined />,
        key: "CANCEL_SCHEDULE",
        onClick: e => {
          e.domEvent.stopPropagation();
          props.setscheduleEmailCancelModal(true);
        },
      },
      {
        label: "Delete",
        icon: <DeleteIcon size="20" />,
        key: "DELETE",
        danger: true,
        onClick: e => {
          e.domEvent.stopPropagation();
          setdeleteModal(true);
        },
      }
    );
  }

  return (
    <div
      className={`p-5 flex-col-centered ${
        isMessageExpanded
          ? "gap-7 !bg-white"
          : props?.index % 2 === 0
          ? "bg-grey-50 border-grey-200"
          : ""
      }`}
    >
      <div
        onClick={() => setIsMessageExpanded(!isMessageExpanded)}
        className="flex-row-centered cursor-pointer w-full gap-2"
      >
        <div>
          <Avatar className="h-7 w-7 ">{convertToInitials(props.thread.from_)}</Avatar>
        </div>
        <div className="flex-col-centered w-full">
          {/* From Details */}
          <div className="flex-row-centered w-full justify-between">
            <div className="flex gap-1">
              <span className="sm-400 text-grey-500">{fromDetails}</span>
              {renderEmailStatus(props.thread.status)}
              {props?.thread?.type !== EMAIL_TYPE_ENUMS.MANUAL && (
                <EmailTypeIcon className="-ml-1" type={props.thread.type} />
              )}
            </div>
            <div className="flex-row-centered items-center gap-2">
              <Tooltip title={convertUtcToLocal(props.thread.createTs, "LLLL")}>
                <span className="xs-400 text-[#00000073]">
                  {dateFromNow(props.thread.createTs)}
                </span>
              </Tooltip>

              <div className="border border-solid flex-row-centered shadow-[0px_2px_0px_0px_#00000005] bg-white border-[#D9D9D9] rounded-md">
                <div
                  onClick={e => {
                    e.stopPropagation();
                    // @ts-ignore
                    setshowReply(prev => ({
                      visible: !prev.visible,
                      email: props.thread.to,
                      id: props.thread.id,
                      showSubject: true,
                      mode: "Reply",
                      emailData: props.thread,
                    }));
                  }}
                  className="p-2 w-8 cursor-pointer flex-row-centered items-center justify-center"
                >
                  <Image preview={false} src={ReplayIcon} />
                </div>

                {canSendEmail && <div className="w-0.2 h-8 border border-solid border-[#D9D9D9]" />}
                {canSendEmail && (
                  <div
                    onClick={e => {
                      e.stopPropagation();
                      setshowReply(prev => ({
                        visible: !prev.visible,
                        email: "",
                        id: props.thread.id,
                        showSubject: true,
                        mode: "Forward",
                        emailData: props.thread,
                      }));
                    }}
                    className="p-2 w-8 -mb-1 cursor-pointer flex-row-centered items-center justify-center"
                  >
                    <ReplyIcon color="#1d2129" className="rotate-180 scale-y-[-1]" />
                  </div>
                )}

                <div className="w-0.2 h-8 border border-solid border-[#D9D9D9]" />
                {/* @ts-ignore */}
                {props?.thread?.scheduled ? (
                  <Dropdown
                    trigger={["click"]}
                    menu={{
                      items: emailScheduledOptions,
                    }}
                  >
                    <div
                      onClick={e => e.stopPropagation()}
                      className="p-2 w-8 flex-row-centered cursor-pointer items-center justify-center"
                    >
                      <DownIcon />
                    </div>
                  </Dropdown>
                ) : (
                  <Dropdown
                    menu={{
                      items: emailActionOptions,
                    }}
                    trigger={["click"]}
                  >
                    <div
                      onClick={e => e.stopPropagation()}
                      className="p-2 w-8 flex-row-centered cursor-pointer items-center justify-center"
                    >
                      <Image src={MoreIcon} preview={false} />
                    </div>
                  </Dropdown>
                )}
              </div>
            </div>
          </div>
          {/* To Details */}
          {isMessageExpanded && (
            <div className="flex-row-centered w-full justify-between">
              <span className="sm-400 text-grey-700">To: {toDetails}</span>
            </div>
          )}
        </div>
      </div>
      <span
        className={`px-[37px] sm-400 text-grey-900 ${
          isMessageExpanded
            ? "whitespace-pre-line"
            : "whitespace-nowrap overflow-hidden text-ellipsis"
        }`}
        // @ts-ignore
        dangerouslySetInnerHTML={{
          __html: isMessageExpanded ? newMessage : cleanHtmlForPreview(newMessage, 200),
        }}
      />
      {props?.thread?.message.mmsObjects?.length > 0 &&
        props?.thread?.message.mmsObjects?.map((item, index) => (
          <span
            className="cursor-pointer max-w-max px-3 border border-solid border-grey-200 rounded-[1111px] text-brand-500"
            onClick={() => window.open(item.mediaUrl)}
            key={index}
          >
            {item.mediaUrl.split("/").pop()}
          </span>
        ))}
      {isReply && isMessageExpanded && (
        <div className="reply-section">
          <span className="toggle-reply cursor-pointer" onClick={() => setIsExpanded(!isExpanded)}>
            {isExpanded ? "..." : "..."}
          </span>

          {isExpanded && (
            <blockquote
              className="border-0 border-l border-solid border-[#ccc] text-[#666] pl-2"
              // @ts-ignore
              dangerouslySetInnerHTML={{ __html: originalMessage }}
            />
          )}
        </div>
      )}
      {showReply?.visible && (
        <Drawer
          open={showReply.visible}
          // @ts-ignore
          onClose={() => setshowReply({ visible: false, email: "" })}
          width="40%"
          destroyOnClose
          title={`Reply to ${
            showReply?.mode === "Reply"
              ? showReply?.email
              : showReply?.emailData?.from_ || showReply.email
          }`}
          footer={
            <div className="flex-row-centered w-full items-center">
              <div className="flex-row-centered gap-1">
                <Button
                  loading={emailLoader || mediaUploadLoader}
                  onClick={() => emailForm.submit()}
                  type="primary"
                >
                  Send
                </Button>
                <Button
                  onClick={() =>
                    setshowReply(
                      // @ts-ignore
                      { visible: false, email: "" }
                    )
                  }
                >
                  Cancel
                </Button>
              </div>
            </div>
          }
        >
          <ReplyEmail
            key={props.thread.id}
            // @ts-ignore
            showReply={showReply}
            // @ts-ignore
            setshowReply={setshowReply}
            selectedLead={null}
            emailForm={emailForm}
            createEmail={createEmail}
            selectedEmail={props.selectedEmail}
            refetchEmails={props.refetchEmails}
            refetchEmailListFn={props.refetchEmailListFn}
            mediaUploadLoader={mediaUploadLoader}
            setMediaUploadLoader={setMediaUploadLoader}
          />
        </Drawer>
      )}
      <CancelScheduleConfirmation
        open={deleteModal}
        setOpen={setdeleteModal}
        cancelText="No"
        okText="Yes, Delete"
        description="Are you sure you want to delete this email?"
        title="Delete email"
        onOk={handleDelete}
        loading={updateStatusLoader}
      />
    </div>
  );
};
